import { type ReactNode } from 'react';

interface FlipCardProps {
  front: ReactNode;
  back: ReactNode;
  className?: string;
}

const GRADIENT_BORDER = 'linear-gradient(331deg, #12403A 12.5%, #2FA696 81.38%)';

export const FlipCard = ({ front, back, className = '' }: FlipCardProps) => (
  <div className={`flip-card h-45 rounded-[10px] p-[2px] ${className}`} style={{ background: GRADIENT_BORDER }}>
    <div className="flip-card-inner relative h-full w-full rounded-lg">
      <div className="flip-card-face bg-theme-white absolute inset-0 overflow-hidden rounded-lg">{front}</div>
      <div className="flip-card-back bg-theme-white absolute inset-0 overflow-hidden rounded-lg">{back}</div>
    </div>
  </div>
);
